import { baseBUCGet } from '../base/baseBUC';

const int = 0;
const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const receiptModelGet = ({
    buildingId = '',
    expenseTemplateId = '',
    receiptGenerateds = 0,
    userId = '',
}) => {
    return {
        //buildingId: buildingId,
        expenseTemplateId: expenseTemplateId,
        //userId: userId,
        balance: decimal,
        //created: dateTimeStr,
        date: dateTimeStr,
        description: str,
        from: dateTimeStr,
        isClose: false,
        isCloseDate: dateTimeStr,
        isOpen: false,
        isOpenDate: dateTimeStr,
        number: int,
        receiptGenerateds: receiptGenerateds,
        to: dateTimeStr,
        total: decimal,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};